import React from 'react'
import PropTypes from 'prop-types'
import { Chart } from 'react-google-charts'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

import { useGetQuery } from '../../lib/api/get'

export const Dashboard = ({ isLocalEnvironment, routeData, authDetails }) => {
  if (authDetails.orgRole === 'Terminal') {
    const navigate = useNavigate()
    navigate('/console/check-in')
  }
  const [time, setTime] = React.useState(dayjs().format('HH:mm a MM/DD/YYYY'))
  var today = new Date()
  let timeNow
  var curHr = today.getHours()

  if (curHr < 12) {
    timeNow = 'Morning'
  } else if (curHr < 18) {
    timeNow = 'Afternoon'
  } else {
    timeNow = 'Evening'
  }

  const modSchema = JSON.parse(routeData.apiEndPointSchema)
  const isUserEnabled = modSchema.enabledFor?.filter((f) => f === authDetails.orgRole) || []

  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'roomRatio',
    params: '',
    enabled: isUserEnabled.length && isUserEnabled.length === 1 ? true : false,
    isDynamic: true,
    doPolling: { interval: 300000 },
  })

  React.useEffect(() => {
    if (getData.dataUpdatedAt) {
      setTime(dayjs(getData.dataUpdatedAt).format('HH:mm a MM/DD/YYYY'))
    }
  }, [getData])

  if (getData.isLoading) {
    return (
      <div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '20%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  const rr = []
  const headers = ['Rooms', 'Students', 'Staff']
  getData.data?.formData?.map((r) => rr.push([r.classroomName, r.student_count, r.staff_count]))
  const roomRatio = [headers, ...rr]
  // let isAccessible = isUserEnabled
  // if (
  //   authDetails.orgRole === 'Office Staff' ||
  //   authDetails.orgRole === 'Staff' ||
  //   authDetails.orgRole === 'Staff Admin'
  // ) {
  //   isAccessible = isUserEnabled
  // }

  return (
    <>
      <div className="trtui-row">
        <div className="trtui-col">
          <div className="trtui-h-100">
            <div className="trtui-row trtui-mb-3 trtui-pb-1">
              <div className="trtui-col-12">
                <div className="trtui-d-flex trtui-align-items-lg-center trtui-flex-lg-row trtui-flex-column">
                  <div className="trtui-flex-grow-1">
                    <h4 className="trtui-fs-16 trtui-mb-1">Good {timeNow}!</h4>
                    <p className="trtui-text-muted trtui-mb-0">
                      Here&apos;s what&apos;s happening today.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isUserEnabled && isUserEnabled.length && isUserEnabled.length > 0 ? (
        <div key={`${getData}${time}`} className="trtui-row">
          <div className="trtui-col-12">
            <div className="trtui-card">
              <div className="trtui-card-header trtui-align-items-center trtui-d-flex">
                <h4 className="trtui-card-title trtui-mb-0 trtui-flex-grow-1">Room Ratio</h4>
                <div className="trtui-flex-shrink-0">{time}</div>
              </div>
              <div className="trtui-card-body">
                <div className="trtui-row">
                  <div className="trtui-col-md-7">
                    <div className="trtui-table-responsive trtui-table-card">
                      <table className="trtui-table trtui-table-hover trtui-table-centered trtui-align-middle trtui-table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>Room Name</th>
                            <th>Students</th>
                            <th>Staff</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getData.data?.formData?.length > 1
                            ? getData.data?.formData?.map((r, rInd) => (
                                <tr key={rInd}>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div>
                                        <h6 className="fs-14 my-1">
                                          <span className="text-reset">{r.classroomName}</span>
                                        </h6>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <h6 className="fs-14 my-1 fw-normal">{r.student_count}</h6>
                                  </td>
                                  <td>
                                    <h6 className="fs-14 my-1 fw-normal">{r.staff_count}</h6>
                                  </td>
                                </tr>
                              ))
                            : null}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="trtui-col-md-5">
                    <Chart chartType="Bar" width="100%" height="20rem" data={roomRatio} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="trtui-row">
          <div className="trtui-col-12">
            <div className="trtui-card trtui-card-animate">
              <div className="trtui-card-body">
                <div className="trtui-d-flex trtui-align-items-center">
                  <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                    <p className="trtui-text-uppercase trtui-fw-medium trtui-text-muted trtui-text-truncate trtui-mb-0">
                      {' '}
                      dashboard
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

Dashboard.propTypes = {
  isLocalEnvironment: PropTypes.string,
  routeData: PropTypes.object,
  authDetails: PropTypes.object,
}
